import { useState } from "react";

function getInitials(name = "") {
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

/**
 * Persona avatar with graceful fallback. Tries to load
 * /assets/avatars/{id}.png; falls back to initials in a styled circle
 * (see .persona-avatar in global.css) when the image is missing or
 * fails to load.
 */
export default function Avatar({ persona, className = "persona-avatar" }) {
  const [failed, setFailed] = useState(false);
  if (!persona) return <div className={className} />;

  const src = `/assets/avatars/${persona.avatar || persona.id}.png`;

  return (
    <div className={className}>
      {failed ? (
        getInitials(persona.name)
      ) : (
        <img
          src={src}
          alt={persona.name}
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
